import { render, staticRenderFns } from "./leButton.vue?vue&type=template&id=a802055a&scoped=true"
import script from "./leButton.vue?vue&type=script&lang=js"
export * from "./leButton.vue?vue&type=script&lang=js"
import style0 from "./leButton.vue?vue&type=style&index=0&id=a802055a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a802055a",
  null
  
)

export default component.exports